import { render } from "./ShowSeparatas.vue?vue&type=template&id=e9d1481c&scoped=true"
import script from "./ShowSeparatas.vue?vue&type=script&lang=js"
export * from "./ShowSeparatas.vue?vue&type=script&lang=js"

import "./ShowSeparatas.vue?vue&type=style&index=0&id=e9d1481c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e9d1481c"

export default script